module.exports = __webpack_public_path__ + "img/Group 3009.5cf72442.svg";